import { imPayInstance } from '../../config/axios';
import store from '../index';

function initialState() {
  return {
    isResetPassword: false,
    redirectPath: null,
  };
}

const actions = {
  putRequestResetPassword(_, data) {
    return new Promise((resolve, reject) => {
      imPayInstance().put('/auth/request-password-reset', data)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },

  putResetPassword(_, data) {
    return new Promise((resolve, reject) => {
      imPayInstance().put('/auth/reset-password', data)
        .then(response => {
          let res = response.data;
          let token = res.data.access_token;
          let workspaceName = res.data.workspaces[0].name;
          let workspaceId = res.data.workspaces[0].id;
          let tokenExpiresIn = res.data.access_token_expires_in + 's';
          let status = true;

          store.dispatch('setAuthorization', { token, workspaceName, workspaceId, tokenExpiresIn, status});

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  putChangePassword({commit}, data) {
    return new Promise((resolve, reject) => {
      imPayInstance().put('/auth/change-password', data)
        .then(res => {
          let resData = res.data;

          commit('setIsResetPassword', resData.data.is_reset_password);

          resolve(resData);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
};

const getters = {
  getIsResetPassword(state) {
    return state.isResetPassword;
  },

  getRedirectPath(state) {
    return state.redirectPath;
  },
};

const mutations = {
  setIsResetPassword(state, status) {
    state.isResetPassword = status;
  },

  setRedirectPath(state, path) {
    state.redirectPath = path;
  },
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  getters,
  mutations,
};